import { render, staticRenderFns } from "./Monitors-Edit.vue?vue&type=template&id=43128efa&lang=pug"
import script from "./Monitors-Edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./Monitors-Edit.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports